// Кэш «конфиг → флаг страны» для вкладок настроек (Почта, Саппы и т.д.) и
// группировки в пикере конфигов.
//
// Раньше флаги вычислялись догрузкой КАЖДОГО конфига отдельным запросом
// (N конфигов = N запросов), из-за чего страны в списке «проявлялись»
// постепенно. Теперь сервер отдаёт флаг прямо в списке конфигов — один
// запрос на все флаги. Плюс SWR-кэш в localStorage: при следующей загрузке
// страницы флаги отдаются мгновенно из кэша, а сеть тихо ревалидирует их.
import { getLocalConfigsList, loadLocalConfig } from './configUtils';

const FLAGS_LS_KEY = 'cache:configFlags';

const readLsFlags = () => {
    try {
        const raw = localStorage.getItem(FLAGS_LS_KEY);
        const obj = raw ? JSON.parse(raw) : null;
        return obj && typeof obj === 'object' ? obj : null;
    } catch (_) {
        return null;
    }
};

// Сеем кэш из localStorage сразу — чтобы getCachedConfigFlags() отдавал
// прошлые флаги мгновенно, до ответа сети
let cache = readLsFlags();   // { filename: 'ar', ... } | null
let inflight = null;         // промис текущей ревалидации

export const getCachedConfigFlags = () => cache || {};

// Всегда ходит в сеть за свежими флагами (revalidate). Вызывающий уже
// мог показать прошлые флаги через getCachedConfigFlags() — здесь мы их
// обновляем и возвращаем актуальную карту.
export const loadConfigFlags = () => {
    if (inflight) return inflight;
    inflight = (async () => {
        const flags = {};
        try {
            const configs = await getLocalConfigsList();
            // Быстрый путь: сервер уже вернул флаг в списке — без догрузки файлов
            const serverProvidesFlags = (configs || []).some(
                (c) => c && Object.prototype.hasOwnProperty.call(c, 'flag')
            );
            if (serverProvidesFlags) {
                (configs || []).forEach((c) => {
                    const filename = c.filename || c.name || c;
                    if (c && c.flag) flags[filename] = c.flag;
                });
            } else {
                // Fallback (старый сервер без флагов в списке): догружаем конфиги
                await Promise.all((configs || []).map(async (config) => {
                    const filename = config.filename || config.name || config;
                    try {
                        const cfg = await loadLocalConfig(filename);
                        if (cfg?.selectedFlag) flags[filename] = cfg.selectedFlag;
                    } catch (_) { /* конфиг не прочитался — покажем глобус */ }
                }));
            }
            cache = flags;
            try { localStorage.setItem(FLAGS_LS_KEY, JSON.stringify(flags)); } catch (_) { /* quota */ }
        } catch (_) {
            // Сеть недоступна — оставляем прошлый кэш, если он есть
            inflight = null;
            return cache || {};
        }
        inflight = null;
        return cache;
    })();
    return inflight;
};
